
import { computed, defineComponent, ref } from 'vue'

import { AxiosError } from 'axios'
import NewslettersSignupEmail from '~/components/NewslettersSignup/steps/NewslettersSignupEmail.vue'
import NewslettersSignupPersonalInformation from '~/components/NewslettersSignup/steps/NewslettersSignupPersonalInformation.vue'
import NewslettersSignupThankYou from '~/components/NewslettersSignup/steps/NewslettersSignupThankYou.vue'
import AppTransition from '~/components/AppTransition'

export default defineComponent({
  name: 'NewslettersSignup',
  components: {
    AppTransition,
    NewslettersSignupEmail,
    NewslettersSignupPersonalInformation,
  },
  setup () {
    const subscriptionId = ref('')
    const isFailed = ref(false)

    const onStepSubmit = (fn?: (...args: any[]) => void) => {
      return (...args: any[]) => {
        if (fn) {
          fn(...args)
        }

        if (currentStepIndex.value < formSteps.length - 1) {
          currentStepIndex.value++
        }
      }
    }

    const onFailure = (e: Error) => {
      // If the subscription already exists, just show the "thank you" step
      if ((e as AxiosError).response && (e as AxiosError).response?.status === 409) {
        currentStepIndex.value = formSteps.length - 1
        return
      }

      isFailed.value = true
    }

    const onSubscriptionCreated = (id: string) => {
      subscriptionId.value = id
    }

    const onSubscriptionUpdated = () => {
      return undefined
    }

    const formSteps = [
      {
        component: NewslettersSignupEmail,
        onSubmit: onStepSubmit(onSubscriptionCreated),
      },
      {
        component: NewslettersSignupPersonalInformation,
        onSubmit: onStepSubmit(onSubscriptionUpdated),
      },
      {
        component: NewslettersSignupThankYou,
        onSubmit: onStepSubmit(),
      },
    ]

    const currentStepIndex = ref(0)
    const currentStep = computed(() => formSteps[currentStepIndex.value])

    return {
      subscriptionId,
      formSteps,
      currentStep,
      onFailure,
    }
  },
})
